import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
import { BoxIcon } from 'lucide-react';
interface ButtonProps extends Omit<HTMLMotionProps<'button'>, 'children'> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  icon?: BoxIcon;
  fullWidth?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  icon: Icon,
  fullWidth = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold rounded-full transition-colors focus:outline-none focus:ring-4 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    primary: 'bg-gradient-to-r from-candy-pink to-candy-purple text-white shadow-lg shadow-candy-pink/30 hover:shadow-candy-pink/50 border-2 border-transparent',
    secondary: 'bg-candy-yellow text-candy-dark shadow-lg shadow-candy-yellow/30 hover:shadow-candy-yellow/50 border-2 border-transparent',
    outline: 'bg-white text-candy-purple border-2 border-candy-purple hover:bg-candy-purple/10',
    ghost: 'bg-transparent text-candy-dark hover:bg-candy-lavender/30'
  };
  const sizes = {
    sm: 'text-sm px-4 py-2 h-9',
    md: 'text-base px-6 py-3 h-12',
    lg: 'text-lg px-8 py-4 h-14'
  };
  return <motion.button whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className}`} {...props} data-id="element-190">
      {Icon && <Icon className={`mr-2 ${size === 'lg' ? 'w-6 h-6' : 'w-5 h-5'}`} data-id="element-191" />}
      {children}
    </motion.button>;
}